import React from 'react';

const InfoIcon = ({
    fill,
    width,
    height,
    opacity
}: {
    fill?: string;
    width?: number;
    height?: number;
    opacity?: number;
}) => (
    <svg width={width} height={height} viewBox="0 0 20 21">
        <g fill="none" fillRule="nonzero" transform="translate(-10 -12)">
            <path
                opacity={opacity}
                fill={fill}
                id="infoIcon"
                d="M20 12c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10 5.522 0 10-4.478 10-10 0-5.523-4.478-10-10-10zm2.081 15.498c-.514.203-.924.357-1.231.464a3.25 3.25 0 0 1-1.069.16c-.623 0-1.108-.152-1.453-.456a1.472 1.472 0 0 1-.518-1.158c0-.182.013-.368.038-.558.027-.19.068-.402.125-.642l.644-2.276c.057-.218.106-.425.145-.618.039-.195.057-.374.057-.536 0-.29-.06-.493-.179-.607-.121-.115-.349-.17-.688-.17-.166 0-.337.024-.512.076a7.276 7.276 0 0 0-.448.149l.17-.701c.421-.172.825-.32 1.21-.441.386-.124.75-.185 1.093-.185.618 0 1.096.15 1.432.449.334.299.503.687.503 1.165 0 .099-.012.273-.035.522-.023.25-.066.477-.129.687l-.64 2.268c-.053.182-.1.39-.142.623-.041.233-.062.411-.062.53 0 .302.067.507.203.617.133.109.368.164.7.164.156 0 .332-.028.53-.082.196-.054.338-.103.428-.144l-.172.7zm-.113-9.209a1.53 1.53 0 0 1-1.08.417c-.42 0-.782-.14-1.083-.417a1.33 1.33 0 0 1-.451-1.01c0-.393.152-.732.45-1.012.302-.281.665-.421 1.084-.421.421 0 .782.14 1.08.42.299.28.449.62.449 1.013 0 .395-.15.732-.45 1.01z"
            />
        </g>
    </svg>
);

export default InfoIcon;
